var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('TheTopbar'),_c('router-view',{staticClass:"w-full",attrs:{"id":"main"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }